<template>
    <div class="header-box">
        <span></span>
        <div>
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "InnerHeader"
    }
</script>

<style scoped>
.header-box {
    display: flex;
    height: 30px;
    align-items: center;
    margin-bottom: 2rem;
    margin-top: 1rem;
}
.header-box span {
    width: 5px;
    height: 16px;
    background-color: #cc0033;
    border-radius: 2px;
}
.header-box {
    /*text-align: center;*/
    width: 100%;
}
.header-box div {
    /*height: 100%;*/
    align-items: center;
    font-weight: 600;
    margin-left: 6px;
    font-size: 1rem;
    width: 100%;
} 
</style>